import { RoadmapTimeline } from "@/types";

export const skyflowSampleRoadmap: RoadmapTimeline = {
  id: 'skyflow-roadmap-2024',
  name: 'Skyflow Data Privacy Vault - 2024 Roadmap',
  startDate: '2024-01-01',
  endDate: '2024-12-31',
  features: [
    {
      id: 'sf-001',
      name: 'Multi-Region Data Residency',
      description: 'Enable customers to specify data residency requirements across multiple geographic regions',
      priority: 'critical',
      effort: 8,
      impact: 9,
      category: 'Data Privacy',
      dependencies: [],
      estimatedHours: 480,
      assignedTeam: 'Platform Engineering',
      status: 'development',
      quarter: 'Q1 2024'
    },
    {
      id: 'sf-002',
      name: 'Advanced Tokenization Engine',
      description: 'Enhanced tokenization with format-preserving encryption and custom token policies',
      priority: 'high',
      effort: 7,
      impact: 8,
      category: 'Security',
      dependencies: ['sf-001'],
      estimatedHours: 320,
      assignedTeam: 'Security Team',
      status: 'planning',
      quarter: 'Q1 2024'
    },
    {
      id: 'sf-003',
      name: 'Real-time Data Classification',
      description: 'AI-powered automatic classification of sensitive data types in real-time',
      priority: 'high',
      effort: 9,
      impact: 8,
      category: 'AI/ML',
      dependencies: ['sf-002'],
      estimatedHours: 560,
      assignedTeam: 'AI/ML Team',
      status: 'backlog',
      quarter: 'Q2 2024'
    },
    {
      id: 'sf-004',
      name: 'Compliance Dashboard 2.0',
      description: 'Enhanced compliance reporting with GDPR, CCPA, HIPAA audit trails',
      priority: 'medium',
      effort: 6,
      impact: 7,
      category: 'Compliance',
      dependencies: ['sf-003'],
      estimatedHours: 240,
      assignedTeam: 'Compliance Team',
      status: 'backlog',
      quarter: 'Q2 2024'
    },
    {
      id: 'sf-005',
      name: 'Zero-Trust API Gateway',
      description: 'Implement zero-trust architecture for all API communications',
      priority: 'critical',
      effort: 8,
      impact: 9,
      category: 'Security',
      dependencies: ['sf-001'],
      estimatedHours: 400,
      assignedTeam: 'Security Team',
      status: 'backlog',
      quarter: 'Q2 2024'
    },
    {
      id: 'sf-006',
      name: 'Federated Identity Management',
      description: 'Support for enterprise SSO and federated identity providers',
      priority: 'medium',
      effort: 5,
      impact: 6,
      category: 'Identity',
      dependencies: ['sf-005'],
      estimatedHours: 200,
      assignedTeam: 'Identity Team',
      status: 'backlog',
      quarter: 'Q3 2024'
    },
    {
      id: 'sf-007',
      name: 'Data Lineage Tracking',
      description: 'Complete visibility into data flow and transformation history',
      priority: 'medium',
      effort: 7,
      impact: 7,
      category: 'Data Governance',
      dependencies: ['sf-004'],
      estimatedHours: 280,
      assignedTeam: 'Data Engineering',
      status: 'backlog',
      quarter: 'Q3 2024'
    },
    {
      id: 'sf-008',
      name: 'Mobile SDK Enhancement',
      description: 'Native iOS and Android SDKs with biometric authentication',
      priority: 'high',
      effort: 6,
      impact: 8,
      category: 'Mobile',
      dependencies: ['sf-006'],
      estimatedHours: 320,
      assignedTeam: 'Mobile Team',
      status: 'backlog',
      quarter: 'Q3 2024'
    },
    {
      id: 'sf-009',
      name: 'Quantum-Resistant Cryptography',
      description: 'Implement post-quantum cryptographic algorithms for future-proofing',
      priority: 'low',
      effort: 9,
      impact: 6,
      category: 'Security',
      dependencies: ['sf-005'],
      estimatedHours: 480,
      assignedTeam: 'Cryptography Team',
      status: 'backlog',
      quarter: 'Q4 2024'
    },
    {
      id: 'sf-010',
      name: 'Edge Computing Support',
      description: 'Deploy data vaults at edge locations for reduced latency',
      priority: 'medium',
      effort: 8,
      impact: 7,
      category: 'Infrastructure',
      dependencies: ['sf-001'],
      estimatedHours: 400,
      assignedTeam: 'Infrastructure Team',
      status: 'backlog',
      quarter: 'Q4 2024'
    }
  ],
  milestones: [
    {
      id: 'ms-001',
      name: 'Q1 Security Foundation',
      description: 'Complete multi-region support and advanced tokenization',
      date: '2024-03-31',
      status: 'in-progress',
      dependencies: ['sf-001', 'sf-002']
    },
    {
      id: 'ms-002',
      name: 'Q2 AI-Powered Compliance',
      description: 'Launch real-time classification and enhanced compliance dashboard',
      date: '2024-06-30',
      status: 'upcoming',
      dependencies: ['sf-003', 'sf-004']
    },
    {
      id: 'ms-003',
      name: 'Q3 Enterprise Integration',
      description: 'Deploy federated identity and data lineage capabilities',
      date: '2024-09-30',
      status: 'upcoming',
      dependencies: ['sf-006', 'sf-007', 'sf-008']
    },
    {
      id: 'ms-004',
      name: 'Q4 Future-Ready Platform',
      description: 'Complete quantum-resistant crypto and edge computing rollout',
      date: '2024-12-31',
      status: 'upcoming',
      dependencies: ['sf-009', 'sf-010']
    }
  ]
};

export const veracodeSampleRoadmap: RoadmapTimeline = {
  id: 'veracode-roadmap-2024',
  name: 'Veracode Application Security Platform - 2024 Roadmap',
  startDate: '2024-01-01',
  endDate: '2024-12-31',
  features: [
    {
      id: 'vc-001',
      name: 'AI-Powered Vulnerability Assessment',
      description: 'Machine learning algorithms to predict and prioritize vulnerabilities',
      priority: 'critical',
      effort: 9,
      impact: 10,
      category: 'AI/ML',
      dependencies: [],
      estimatedHours: 720,
      assignedTeam: 'AI Research Team',
      status: 'development',
      quarter: 'Q1 2024'
    },
    {
      id: 'vc-002',
      name: 'Container Security Scanning',
      description: 'Native support for Docker and Kubernetes security scanning',
      priority: 'critical',
      effort: 8,
      impact: 9,
      category: 'DevSecOps',
      dependencies: [],
      estimatedHours: 480,
      assignedTeam: 'Container Security Team',
      status: 'development',
      quarter: 'Q1 2024'
    },
    {
      id: 'vc-003',
      name: 'CI/CD Pipeline Integration',
      description: 'Seamless integration with GitLab, GitHub Actions, and Jenkins',
      priority: 'high',
      effort: 6,
      impact: 8,
      category: 'DevSecOps',
      dependencies: ['vc-002'],
      estimatedHours: 320,
      assignedTeam: 'DevOps Team',
      status: 'planning',
      quarter: 'Q1 2024'
    },
    {
      id: 'vc-004',
      name: 'Supply Chain Risk Analysis',
      description: 'Analyze third-party components and dependencies for security risks',
      priority: 'high',
      effort: 7,
      impact: 8,
      category: 'Supply Chain',
      dependencies: ['vc-001'],
      estimatedHours: 400,
      assignedTeam: 'Supply Chain Security',
      status: 'backlog',
      quarter: 'Q2 2024'
    },
    {
      id: 'vc-005',
      name: 'Zero-Day Threat Intelligence',
      description: 'Real-time threat intelligence feed for zero-day vulnerabilities',
      priority: 'critical',
      effort: 8,
      impact: 9,
      category: 'Threat Intelligence',
      dependencies: ['vc-001'],
      estimatedHours: 560,
      assignedTeam: 'Threat Research Team',
      status: 'backlog',
      quarter: 'Q2 2024'
    },
    {
      id: 'vc-006',
      name: 'Developer Security Training',
      description: 'Interactive security training modules with code examples',
      priority: 'medium',
      effort: 5,
      impact: 7,
      category: 'Education',
      dependencies: ['vc-003'],
      estimatedHours: 280,
      assignedTeam: 'Education Team',
      status: 'backlog',
      quarter: 'Q2 2024'
    },
    {
      id: 'vc-007',
      name: 'Behavioral Code Analysis',
      description: 'Analyze application behavior to detect anomalous patterns',
      priority: 'high',
      effort: 9,
      impact: 8,
      category: 'Behavioral Analytics',
      dependencies: ['vc-001'],
      estimatedHours: 640,
      assignedTeam: 'Behavioral Analytics Team',
      status: 'backlog',
      quarter: 'Q3 2024'
    },
    {
      id: 'vc-008',
      name: 'Compliance Automation Engine',
      description: 'Automated compliance reporting for SOC2, ISO27001, PCI-DSS',
      priority: 'medium',
      effort: 6,
      impact: 7,
      category: 'Compliance',
      dependencies: ['vc-004'],
      estimatedHours: 360,
      assignedTeam: 'Compliance Team',
      status: 'backlog',
      quarter: 'Q3 2024'
    },
    {
      id: 'vc-009',
      name: 'API Security Gateway',
      description: 'Dedicated API security scanning and runtime protection',
      priority: 'high',
      effort: 7,
      impact: 8,
      category: 'API Security',
      dependencies: ['vc-005'],
      estimatedHours: 420,
      assignedTeam: 'API Security Team',
      status: 'backlog',
      quarter: 'Q3 2024'
    },
    {
      id: 'vc-010',
      name: 'Quantum-Safe Security Assessment',
      description: 'Assess applications for quantum computing security threats',
      priority: 'low',
      effort: 8,
      impact: 6,
      category: 'Future Security',
      dependencies: ['vc-007'],
      estimatedHours: 480,
      assignedTeam: 'Future Security Team',
      status: 'backlog',
      quarter: 'Q4 2024'
    },
    {
      id: 'vc-011',
      name: 'Cloud-Native Security Mesh',
      description: 'Service mesh security for microservices architectures',
      priority: 'medium',
      effort: 8,
      impact: 7,
      category: 'Cloud Security',
      dependencies: ['vc-002', 'vc-009'],
      estimatedHours: 520,
      assignedTeam: 'Cloud Security Team',
      status: 'backlog',
      quarter: 'Q4 2024'
    }
  ],
  milestones: [
    {
      id: 'ms-001',
      name: 'Q1 AI-Powered Foundation',
      description: 'Complete AI vulnerability assessment and container security',
      date: '2024-03-31',
      status: 'in-progress',
      dependencies: ['vc-001', 'vc-002', 'vc-003']
    },
    {
      id: 'ms-002',
      name: 'Q2 Intelligence & Supply Chain',
      description: 'Launch threat intelligence and supply chain risk analysis',
      date: '2024-06-30',
      status: 'upcoming',
      dependencies: ['vc-004', 'vc-005', 'vc-006']
    },
    {
      id: 'ms-003',
      name: 'Q3 Behavioral & Compliance',
      description: 'Deploy behavioral analysis and compliance automation',
      date: '2024-09-30',
      status: 'upcoming',
      dependencies: ['vc-007', 'vc-008', 'vc-009']
    },
    {
      id: 'ms-004',
      name: 'Q4 Future-Ready Security',
      description: 'Complete quantum-safe assessment and cloud-native mesh',
      date: '2024-12-31',
      status: 'upcoming',
      dependencies: ['vc-010', 'vc-011']
    }
  ]
};

export const sampleRoadmaps = {
  skyflow: skyflowSampleRoadmap,
  veracode: veracodeSampleRoadmap
};